module.exports = __webpack_public_path__ + "static/media/close.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.svg
// module id = 873
// module chunks = 0